export default {
    products: [],
    totalDataRow:0 
}
  